// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import 'element-ui/lib/theme-chalk/display.css'
import VueTouch from 'vue-touch'
import VueLazyload from 'vue-lazyload'
import VueCookies from 'vue-cookies'
import App from './App'
import router from './router'
import store from './store'
import axios from 'axios'
import qs from 'qs'
import md5 from 'js-md5'
import pathUtils from './util/pathUtils'

Vue.config.productionTip = false
/* 引入element-ui，指定尺寸以及弹窗的默认z-index */
Vue.use(ElementUI, { size: 'small', zIndex: 2000 })
/* 引入VueTouch */
Vue.use(VueTouch, {name: 'v-touch'})
/* 引入cookie工具 */
Vue.use(VueCookies)
/* 引入VueLazyload */
Vue.use(VueLazyload)
/**
 * 登录授权
 */
const accessToken = VueCookies.get('enroll-access-token') || ''
if (accessToken) {
  store.commit('setAccessToken', accessToken)
}
/**
 * axios设置
 */
const $axios = axios.create({
  headers: {
    'Content-Type': 'application/x-www-form-urlencoded',
    'Accept': 'text/html, */*',
    'X-Requested-With': 'XMLHttpRequest'
  }
})

$axios.interceptors.request.use(config => {
  return new Promise((resolve, reject) => {
    let requestUrl = config.url
    if (requestUrl && requestUrl.startsWith('/')) {
      config.url = pathUtils.getContextPath(requestUrl)
    }
    store.dispatch('globalRequestHeaders', config.url).then(val => {
      if (val) {
        Object.keys(val).forEach(key => {
          config.headers.common[key] = val[key]
        })
      }
      resolve(config)
    }).catch(err => {
      reject(err)
    })
  })
})

$axios.interceptors.response.use(response => {
  if (response.config) {
    if (!response.config['disableRedirect']) {
      let result = response.data
      if (result) {
        if (result['responseCode'] === 'ERR_SECURITY_AUTHENTICATION') {
          // 需要清除登录信息
          store.commit('clearAuthorize')
          store.commit('delAccessToken')
          // 跳转到登录页面
          let currentRoute = router.currentRoute
          router.replace({path: '/homeIndex', query: {redirect: currentRoute ? currentRoute.path : ''}})
        }
      }
    }
  }
  return response
}, error => {
  Vue.nextTick(() => {
    if (error.response) {
      let errorMsg
      switch (error.response.status) {
        case 401: {
          errorMsg = '登录异常'
          localStorage.removeItem('smba-authorizeObj')
          Vue.$cookies.remove('authorization')
          store.commit('applyAuthorize', null)
          let currentRoute = router.currentRoute
          router.replace({path: '/homeIndex', query: {redirect: currentRoute ? currentRoute.path : ''}})
          break
        }
        case 403: {
          errorMsg = '页面禁止访问'
          break
        }
        case 404: {
          errorMsg = '访问页面不存在'
          break
        }
        case 500: {
          errorMsg = '服务器端发生错误'
          break
        }
        default: {
          errorMsg = '未知错误（代码：' + error.response.status + '）'
          break
        }
      }
      ElementUI.Notification.error({
        title: '访问异常',
        message: errorMsg
      })
    }
  })
  return Promise.reject(error)
})

/* 支持全局事件 */
const bus = new Vue()
Vue.prototype.$bus = bus
/* 引入ajax请求方案 */
Vue.prototype.$ajax = $axios
Vue.prototype.$qs = qs
Vue.prototype.$md5 = md5
Vue.prototype.$extend = function () {
  if (arguments.length > 0) {
    let target = {}
    for (let index = 0; index < arguments.length; index++) {
      let data = arguments[index]
      if (data) {
        for (let key in data) {
          target[key] = data[key]
        }
      }
    }
    return target
  } else {
    return null
  }
}

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js